// extracted by mini-css-extract-plugin
export default {"root":"FoundationValueGrid-module--root--ec3cb","value":"FoundationValueGrid-module--value--0a4a7"};